<template>
  <section
    class="products-breadcrumb"
    resmed-component-name="products-breadcrumb"
  >
    <div class="component">
      <div class="container">
        <span
          ><a v-bind:href="address">{{ $getTranslation("Home", $route.params.region) }}</a>

          <template v-if="tag && origin === 'single'">
            <span class="caret">></span>
            <a v-bind:href="`${address}?tags=${Object.keys(this.tag)[0]}`">{{
              decodeURI(tag[Object.keys(this.tag)[0]])
            }}</a>
          </template>

          <span class="caret">></span>
          <a
            v-if="pageType === 'product_detail'"
            v-bind:href="`${address}/${link}`"
          >
            <span class="text-capitalize"
              >{{ decodeURI(category.split("-").join(" "))
              }}<span class="caret">></span></span
            >
          </a>
          <span class="title d-inline-block" v-html="title"></span>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "products-breadcrumb", // blog-breadcrumb
  props: {
    title: {
      type: String,
    },
    origin: {
      type: String,
      default() {
        return "archive";
      },
    },
    pageType: {
      type: String,
    },
  },
  data() {
    return {
      address: `${window.location.origin}/${this.$route.params.region}`,
      tag: JSON.parse(localStorage.getItem("sleep-blog-query-tag")),
      category: "",
      link: "",
    };
  },
  created() {
    bus.$emit("navigation:reversed", true);
    if (this.pageType === "product_detail") {
      this.category = location.pathname.substr(1).split("/")[1];
      this.link = this.category
        .toLowerCase()
        .split(" ")
        .join("-");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component {
  padding: 1.625rem;

  a {
    color: inherit;
  }

  .caret {
    margin: 0 0.5rem;
    transform: translateY(1px);
    display: inline-block;
  }

  .title {
    text-transform: capitalize;
    p {
      display: inline-block !important;
    }
    @extend %body-normal-bold;
  }
}
</style>
